import { render } from "./PendingCompletedJobs.vue?vue&type=template&id=fa756324"
import script from "./PendingCompletedJobs.vue?vue&type=script&lang=js"
export * from "./PendingCompletedJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__